import { useEffect } from 'react';

import useHotjar from './useHotjar';

import { PollKey } from './types';

interface Props {
  pollKey: PollKey;
}

function HotjarPoll({ pollKey }: Props) {
  const { trigger } = useHotjar();

  useEffect(() => {
    trigger(pollKey);
  }, [trigger, pollKey]);

  return null;
}

export default HotjarPoll;
